import Link from 'next/link';
import { supabase } from '../lib/supabaseClient';
import dynamic from 'next/dynamic';
import { Assets } from '../src/list/Assets';

const Headcom = dynamic(() => import('../src/components/Headcom'));
const FooterCom = dynamic(() => import('../src/components/FooterCom'));
const BlackScreen = dynamic(() => import('../src/components/BlackScreen'));

export async function getStaticProps() {
  let allGames = [];
  let start = 0;
  const limit = 3000;
  let hasMore = true;

  // We loop to fetch all games safely in case of a 1000-row API limit
  while (hasMore) {
    const { data, error } = await supabase
      .from('bestgamespot_games')
      .select('slug, game_name, title')
      .order('created_at', { ascending: false })
      .range(start, start + limit - 1);

    if (error || !data) break;

    allGames = [...allGames, ...data];

    // Supabase has a hard max_rows limit (usually 1000). 
    // If it returns less data than we asked for (or 0), we've hit the end.
    if (data.length === 0 || data.length < 1000) {
      hasMore = false;
    } else {
      start += data.length;
    }
  }

  return {
    props: {
      games: allGames
    },
    revalidate: 60 * 60 // Revalidate once an hour
  };
}

export default function AllGames({ games }) {
  return (
    <>
      <Headcom
        title="All Games - bestgamespot"
        s_dis="Browse our complete collection of free online games available on BestGameSpot."
        path="/all-games"
        logo_512={Assets[0]?.logo_512}
      />

      <div className="app_cont_game">
        <div>
          <BlackScreen />
          <div className="game-root">
            <div className="container" style={{ paddingLeft: 'var(--Left-Padding)', paddingRight: '20px' }}>
              <h1 style={{ color: 'white', marginBottom: '30px', fontSize: '2.5rem', fontWeight: 'bold' }}>
                All Games ({games.length})
              </h1>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                gap: '15px'
              }}>
                {games.map(game => (
                  <Link key={game.slug} href={`/game/${game.slug}`} passHref>
                    <a style={{
                      color: '#8b8b8b',
                      textDecoration: 'none',
                      fontSize: '1.1rem',
                      lineHeight: '1.4',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      backgroundColor: 'rgba(255,255,255,0.03)',
                      border: '1px solid rgba(255,255,255,0.05)',
                      transition: 'all 0.2s ease',
                      display: 'block'
                    }}
                      onMouseOver={(e) => {
                        e.target.style.color = '#fff';
                        e.target.style.backgroundColor = 'rgba(255,255,255,0.08)';
                        e.target.style.borderColor = 'rgba(255,255,255,0.15)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.color = '#8b8b8b';
                        e.target.style.backgroundColor = 'rgba(255,255,255,0.03)';
                        e.target.style.borderColor = 'rgba(255,255,255,0.05)';
                      }}
                    >
                      {game.game_name || game.title}
                    </a>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterCom />
    </>
  );
}
